import { List, Map, fromJS } from 'immutable';

import * as constAction from 'root/actionConstants';
import { listFindByMapId } from 'core/generalFunctions';

const defaultState = Map({
  lista: List(),
  eliminarId: false,
  dispositivoActual: Map(),
  photoTaskUrl: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.DISPOSITIVO_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.DISPOSITIVO_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.DISPOSITIVO_DELETE: {
      let index = listFindByMapId(state.get('lista'), action.state.id, true);
      return state.deleteIn(['lista', index]);
    }
  }
  return state;
}



// WEBPACK FOOTER //
// src/modules/dispositivos/reducer.js